import { createAction, props } from '@ngrx/store';

export const getGmails = createAction(
  '[Google] Get  Gmails',
  props<{ email: string; page: any }>()
);

export const getGmailsSuccess = createAction(
  '[Google] Get  Gmails Success',
  props<{ new_gmails: any }>()
);

export const getGmailsFailure = createAction(
  '[Google] Get Gmails Failure',
  props<{ error: any }>()
);
